(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-commit"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-about-commit]').forEach(function(sec){
    var items=[].slice.call(sec.querySelectorAll('.citem')), imgs=[].slice.call(sec.querySelectorAll('.commit__img'));
    items.forEach(function(it){
      it.querySelector('.citem__head').addEventListener('click',function(){
        if(it.classList.contains('is-open'))return;
        items.forEach(function(x){x.classList.remove('is-open');});
        imgs.forEach(function(im){im.classList.remove('is-on');});
        it.classList.add('is-open');
        var img=sec.querySelector('.commit__img[data-i="'+it.getAttribute('data-i')+'"]');
        if(img)img.classList.add('is-on');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-hero"]) return;
  try {
    
(function(){
  document.querySelectorAll('[data-about-hero]').forEach(function(ah){
    var mask=ah.querySelector('.ah__mask'), video=ah.querySelector('.ah__video'), cue=ah.querySelector('.ah__cue');
    function upd(){
      var r=ah.getBoundingClientRect(), travel=r.height-window.innerHeight;
      var p=travel>0?Math.min(Math.max(-r.top/travel,0),1):0;
      var mp=Math.min(p/0.5,1);
      if(mask)mask.style.opacity=mp;
      if(video)video.style.transform='scale('+(1.12-0.12*mp).toFixed(4)+')';
      if(cue)cue.style.opacity=Math.max(1-p/0.22,0);
    }
    window.addEventListener('scroll',upd,{passive:true});
    window.addEventListener('resize',upd);
    upd();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-milestone"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-about-mile]').forEach(function(mile){
    var track=mile.querySelector('[data-mile-track]'), mvp=mile.querySelector('.mile__viewport'),
        svg=mile.querySelector('[data-mile-svg]'), path=mile.querySelector('[data-mile-path]'),
        yearsWrap=mile.querySelector('[data-mile-years]');
    var nodes=[].slice.call(track.querySelectorAll('.mnode'));
    var yearBtns=[].slice.call(yearsWrap.querySelectorAll('.mile__year'));
    if(!nodes.length)return;
    var mLen=0, mCur=-1;
    function layout(){
      var H=mvp.clientHeight, W=track.scrollWidth;
      var cy=H*0.5, A=Math.min(118,H*0.15), waves=1.25, phase=-0.6;
      function cyAt(x){ return cy + A*Math.sin((x/W)*Math.PI*2*waves+phase); }
      svg.setAttribute('width',W); svg.setAttribute('height',H); svg.setAttribute('viewBox','0 0 '+W+' '+H);
      var d='', N=Math.max(48,Math.floor(W/22));
      for(var i=0;i<=N;i++){ var x=W*i/N, y=cyAt(x); d+=(i?'L':'M')+x.toFixed(1)+' '+y.toFixed(1)+' '; }
      path.setAttribute('d',d);
      mLen=path.getTotalLength(); path.style.strokeDasharray=mLen; path.style.strokeDashoffset=mLen;
      nodes.forEach(function(n){
        var x=n.offsetLeft, y=cyAt(x), dot=n.querySelector('.mnode__dot'), card=n.querySelector('.mnode__card');
        dot.style.top=y+'px';
        if(n.className.indexOf('mnode--up')>-1){ card.style.top='auto'; card.style.bottom=(H-y+46)+'px'; }
        else { card.style.bottom='auto'; card.style.top=(y+46)+'px'; }
      });
    }
    function sectionTop(){ return mile.getBoundingClientRect().top + window.scrollY; }
    function maxX(){ return Math.max(0, track.scrollWidth - mvp.clientWidth); }
    function goto(i){ var travel=mile.offsetHeight-window.innerHeight, n=nodes.length, p=n>1?i/(n-1):0;
      window.scrollTo({top:sectionTop()+p*travel, behavior:'smooth'}); }
    function update(){
      var r=mile.getBoundingClientRect(), travel=mile.offsetHeight-window.innerHeight;
      var p=travel>0?Math.min(Math.max(-r.top/travel,0),1):0, mx=maxX();
      track.style.transform='translateX('+(-p*mx).toFixed(2)+'px)';
      var dp=Math.min(1,p*1.08+0.1); path.style.strokeDashoffset=(mLen*(1-dp)).toFixed(1);
      var focusX=Math.max(90, mvp.clientWidth*0.16), best=0, bd=1e9;
      for(var i=0;i<nodes.length;i++){ var dx=nodes[i].offsetLeft-p*mx, dd=Math.abs(dx-focusX); if(dd<bd){bd=dd;best=i;} }
      if(best!==mCur){ mCur=best;
        for(var j=0;j<nodes.length;j++) nodes[j].classList.toggle('is-active',j===best);
        for(var k=0;k<yearBtns.length;k++) yearBtns[k].classList.toggle('on',k===best);
        var ab=yearBtns[best];
        if(ab){ var target=ab.offsetLeft-(yearsWrap.clientWidth-ab.offsetWidth)/2;
          yearsWrap.scrollTo({left:Math.max(0,target),behavior:'smooth'}); }
      }
    }
    layout(); window.addEventListener('resize',layout);
    window.addEventListener('scroll',update,{passive:true}); window.addEventListener('resize',update); update();
    yearBtns.forEach(function(b){ b.addEventListener('click',function(){ goto(+b.getAttribute('data-i')); }); });
    var prev=mile.querySelector('[data-mile-prev]'), next=mile.querySelector('[data-mile-next]');
    if(prev)prev.addEventListener('click',function(){ goto(Math.max(0,(mCur<0?0:mCur)-1)); });
    if(next)next.addEventListener('click',function(){ goto(Math.min(nodes.length-1,(mCur<0?0:mCur)+1)); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-mission"]) return;
  try {
    
(function(){
  function ss(a,b,x){x=(x-a)/(b-a);x=x<0?0:(x>1?1:x);return x*x*(3-2*x);}
  document.querySelectorAll('[data-about-msv]').forEach(function(msv){
    var s=msv.querySelectorAll('.msv__slide'); if(s.length<2)return;
    function upd(){
      var r=msv.getBoundingClientRect(), travel=msv.offsetHeight-window.innerHeight;
      var p=travel>0?Math.min(Math.max(-r.top/travel,0),1):0;
      var o0=1-ss(0.36,0.5,p), o1=ss(0.5,0.64,p);
      s[0].style.opacity=o0; s[0].style.transform='translateY('+(-34*(1-o0))+'px)';
      s[1].style.opacity=o1; s[1].style.transform='translateY('+(34*(1-o1))+'px)';
    }
    window.addEventListener('scroll',upd,{passive:true});
    window.addEventListener('resize',upd);
    upd();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliate-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.affaq .fq').forEach(function(fq){
  fq.querySelector('.fq__q').addEventListener('click',function(){
    var open=fq.classList.contains('is-open');
    document.querySelectorAll('.affaq .fq').forEach(function(x){x.classList.remove('is-open');});
    if(!open)fq.classList.add('is-open');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var annWrap=document.getElementById('annMsgs');
  var anns=annWrap?[].slice.call(annWrap.children):[];
  if(!anns.length)return;
  var ai=0, annTimer;
  function annShow(n){anns[ai].classList.remove('on');ai=(n+anns.length)%anns.length;anns[ai].classList.add('on');}
  function annStart(){if(reduce||anns.length<2)return;annTimer=setInterval(function(){annShow(ai+1);},4200);}
  document.querySelectorAll('[data-ann]').forEach(function(b){b.addEventListener('click',function(){clearInterval(annTimer);annShow(ai+parseInt(b.dataset.ann,10));annStart();});});
  var annClose=document.getElementById('annClose');
  if(annClose)annClose.addEventListener('click',function(){var a=document.getElementById('announce');if(a)a.style.display='none';});
  annStart();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function(){
  var drawer=document.querySelector('.cd'), overlay=document.querySelector('.cd-overlay');
  if(!drawer||!overlay)return;
  // re-mount to body (escape any section-group stacking context)
  document.body.appendChild(overlay); document.body.appendChild(drawer);
  var body=drawer.querySelector('[data-cd-body]'), foot=drawer.querySelector('[data-cd-foot]'), sub=drawer.querySelector('[data-cd-subtotal]');
  function money(c){return '$'+(c/100).toFixed(2);}
  function esc(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML;}
  function render(cart){
    if(!cart||!cart.items||!cart.items.length){body.innerHTML='<div class="cd__empty">Your cart is empty.</div>';foot.hidden=true;bubble(cart);chrome(cart);return;}
    body.innerHTML=cart.items.map(function(it){
      var img=it.image?it.image.replace(/(\.[a-zA-Z]+)(\?|$)/,'_160x$1$2'):'';
      return '<div class="cd__item" data-key="'+esc(it.key)+'" data-q="'+it.quantity+'">'
        +(img?'<img src="'+img+'" alt="" loading="lazy">':'<span></span>')
        +'<div class="cd__it-b"><div class="cd__it-t">'+esc(it.product_title)+'</div>'
        +((it.variant_title&&it.variant_title!=='Default Title')?'<div class="cd__it-v">'+esc(it.variant_title)+'</div>':'')
        +'<div class="cd__it-r"><div class="cd__qty"><button type="button" data-dec aria-label="Decrease">−</button><span>'+it.quantity+'</span><button type="button" data-inc aria-label="Increase">+</button></div>'
        +'<span class="cd__it-p">'+money(it.final_line_price)+'</span></div></div>'
        +'<button class="cd__rm" type="button" data-rm aria-label="Remove">×</button></div>';
    }).join('');
    sub.textContent=money(cart.total_price); foot.hidden=false; bubble(cart); chrome(cart);
    body.querySelectorAll('.cd__item').forEach(function(row){
      var key=row.getAttribute('data-key'), q=parseInt(row.getAttribute('data-q'),10);
      var inc=row.querySelector('[data-inc]'),dec=row.querySelector('[data-dec]'),rm=row.querySelector('[data-rm]');
      if(inc)inc.onclick=function(){change(key,q+1);};
      if(dec)dec.onclick=function(){change(key,q-1);};
      if(rm)rm.onclick=function(){change(key,0);};
    });
  }
  function bubble(cart){var el=document.querySelector('#cart-icon-bubble .count');if(el&&cart)el.textContent=cart.item_count;}
  var uprow=drawer.querySelector('[data-cd-uprow]');
  function paginateUp(){
    if(!uprow)return;
    var pager=drawer.querySelector('[data-cd-uppager]'),info=drawer.querySelector('[data-cd-uppageinfo]');
    var prev=drawer.querySelector('[data-cd-upprev]'),next=drawer.querySelector('[data-cd-upnext]');
    var items=[].slice.call(uprow.children).filter(function(c){return c.style.display!=='none';});
    var size=4, pages=Math.ceil(items.length/size)||1, page=0;
    if(!pager)return;
    if(items.length<=size){pager.hidden=true;return;}
    pager.hidden=false;
    function show(){items.forEach(function(el,i){el.style.display=(i>=page*size&&i<(page+1)*size)?'':'none';});
      if(info)info.textContent=(page+1)+' / '+pages; if(prev)prev.disabled=page===0; if(next)next.disabled=page===pages-1;}
    prev.onclick=function(){if(page>0){page--;show();}};
    next.onclick=function(){if(page<pages-1){page++;show();}};
    show();
  }
  function chrome(cart){
    var n=cart?cart.item_count:0;
    var cnt=drawer.querySelector('[data-cd-count]');if(cnt)cnt.textContent=n?('· '+n+(n===1?' item':' items')):'';
    var ship=drawer.querySelector('[data-cd-ship]');var MIN=9900;
    if(ship){if(!n){ship.hidden=true;}else{ship.hidden=false;if(cart.total_price>=MIN){ship.innerHTML='<b>✓ Free shipping unlocked</b><div class="cd-bar"><i style="width:100%"></i></div>';}else{ship.innerHTML='Add <b>'+money(MIN-cart.total_price)+'</b> for free shipping<div class="cd-bar"><i style="width:'+Math.round(cart.total_price/MIN*100)+'%"></i></div>';}}}
    var up=drawer.querySelector('[data-cd-up]');
    if(!up){return;}
    up.hidden=!n;
    if(!n||!cart){return;}
    var inCart={}; cart.items.forEach(function(it){inCart[it.variant_id]=1;});
    uprow.querySelectorAll('.cd__upcard').forEach(function(c){c.style.display=inCart[+c.getAttribute('data-up-id')]?'none':'';});
    if(!uprow.children.length){up.hidden=true;return;}
    paginateUp();
  }
  function refresh(open){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){render(c);if(open)openD();}).catch(function(){if(open)openD();});}
  function change(key,qty){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(render).catch(function(){});}
  function openD(){drawer.classList.add('open');overlay.classList.add('open');overlay.hidden=false;drawer.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
  function closeD(){drawer.classList.remove('open');overlay.classList.remove('open');drawer.setAttribute('aria-hidden','true');document.body.style.overflow='';}
  document.querySelectorAll('[data-cd-close]').forEach(function(el){el.addEventListener('click',closeD);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeD();});
  var icon=document.getElementById('cart-icon-bubble');
  if(icon)icon.addEventListener('click',function(e){e.preventDefault();refresh(true);});
  document.addEventListener('cart:refresh',function(e){refresh(e.detail&&e.detail.open);});
  drawer.addEventListener('click',function(e){
    var btn=e.target.closest('[data-up-add]'); if(!btn)return;
    e.preventDefault();
    var card=btn.closest('.cd__upcard');if(!card)return;
    var id=parseInt(card.getAttribute('data-up-id'),10);
    if(btn.disabled)return; btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){return r.json();}).then(function(){refresh(false);}).catch(function(){}).finally(function(){btn.disabled=false;});
  });
  refresh(false);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.cfaq .fq__q').forEach(function(btn){
    btn.addEventListener('click',function(){ btn.closest('.fq').classList.toggle('is-open'); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){
  var header=document.getElementById('header');
  if(!header)return;
  var lastY=0, megaOpen=false;
  var isPage=header.classList.contains('header--page');
  function onScroll(){
    if(isPage)return;
    var y=window.scrollY, past=y>window.innerHeight*0.72;
    if(!megaOpen){
      header.classList.toggle('solid',past);
      if(past){ if(y>lastY+6)header.classList.add('hide'); else if(y<lastY-6)header.classList.remove('hide'); }
      else header.classList.remove('hide');
    }
    lastY=y;
  }
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  var closeT;
  function megas(){return document.querySelectorAll('.mega');}
  function openMega(id){clearTimeout(closeT);megaOpen=true;header.classList.remove('hide');header.classList.add('mega-open');megas().forEach(function(m){m.classList.toggle('open',m.id==='mega-'+id);});}
  function closeMega(){closeT=setTimeout(function(){megaOpen=false;header.classList.remove('mega-open');megas().forEach(function(m){m.classList.remove('open');});onScroll();},130);}
  document.querySelectorAll('[data-mega]').forEach(function(t){t.addEventListener('mouseenter',function(){openMega(t.dataset.mega);});t.addEventListener('mouseleave',closeMega);});
  megas().forEach(function(m){m.addEventListener('mouseenter',function(){clearTimeout(closeT);});m.addEventListener('mouseleave',closeMega);});
  var drawer=document.getElementById('drawer'), burger=document.querySelector('.burger');
  function closeDrawer(){if(drawer)drawer.classList.remove('open');document.body.style.overflow='';}
  if(burger&&drawer)burger.addEventListener('click',function(){drawer.classList.add('open');document.body.style.overflow='hidden';});
  document.querySelectorAll('[data-drawer-close]').forEach(function(el){el.addEventListener('click',closeDrawer);});
  if(drawer)drawer.querySelectorAll('.drawer__nav a').forEach(function(a){a.addEventListener('click',closeDrawer);});
  if(drawer)drawer.querySelectorAll('.dgrp__t').forEach(function(btn){btn.addEventListener('click',function(){var g=btn.closest('.dgrp');var op=g.classList.toggle('open');btn.setAttribute('aria-expanded',op?'true':'false');});});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});
  document.querySelectorAll('.mega__cats a[data-grp]').forEach(function(a){
    a.addEventListener('mouseenter',function(){
      var mega=a.closest('.mega'),g=a.getAttribute('data-grp');
      mega.querySelectorAll('.mega__cats a[data-grp]').forEach(function(x){x.classList.toggle('is-on',x===a);});
      mega.querySelectorAll('.mgrp').forEach(function(m){m.classList.toggle('is-on',m.getAttribute('data-grp')===g);});
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var hero=document.getElementById('hero'); if(!hero)return;
  var slides=[].slice.call(hero.querySelectorAll('#heroSlides .slide')); if(!slides.length)return;
  var dotsWrap=document.getElementById('heroDots'), hi=0, hTimer;
  if(dotsWrap){slides.forEach(function(_,i){var b=document.createElement('button');b.setAttribute('role','tab');b.setAttribute('aria-label','Slide '+(i+1));b.innerHTML='<span class="fill"></span>';b.addEventListener('click',function(){go(i);});dotsWrap.appendChild(b);});}
  var dots=dotsWrap?[].slice.call(dotsWrap.children):[];
  function paint(){slides.forEach(function(s,i){s.classList.toggle('on',i===hi);});dots.forEach(function(d,i){d.classList.toggle('on',i===hi);});}
  function go(n){hi=(n+slides.length)%slides.length;paint();restart();}
  function restart(){clearInterval(hTimer);if(!reduce&&slides.length>1)hTimer=setInterval(function(){go(hi+1);},6000);}
  var nx=document.getElementById('heroNext'),pv=document.getElementById('heroPrev');
  if(nx)nx.addEventListener('click',function(){go(hi+1);});
  if(pv)pv.addEventListener('click',function(){go(hi-1);});
  hero.addEventListener('mouseenter',function(){clearInterval(hTimer);});
  hero.addEventListener('mouseleave',restart);
  var hSl=document.getElementById('heroSlides'), sx=null, sy=null;
  if(hSl){hSl.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY;},{passive:true});
  hSl.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))go(dx<0?hi+1:hi-1);sx=sy=null;},{passive:true});}
  paint();restart();
})();
(function(){
  document.querySelectorAll('.slide__count[data-wh-cd]').forEach(function(el){
    var t=new Date((el.getAttribute('data-wh-cd')||'').replace(' ','T')).getTime();
    if(isNaN(t)){el.style.display='none';return;}
    var p=function(n){return (n<10?'0':'')+n;};
    var set=function(sel,v){var n=el.querySelector(sel);if(n)n.textContent=v;};
    function tick(){var d=t-Date.now();if(d<0)d=0;
      set('[data-whcd-d]',Math.floor(d/86400000));
      set('[data-whcd-h]',p(Math.floor(d%86400000/3600000)));
      set('[data-whcd-m]',p(Math.floor(d%3600000/60000)));
      set('[data-whcd-s]',p(Math.floor(d%60000/1000)));}
    tick();setInterval(tick,1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-rail"] && !Shopify.designMode) return;
  try {
    
(function(){
  var lineup=document.querySelector('.lineup'); if(!lineup)return;
  var tabs=lineup.querySelectorAll('.ltab');
  var panels=lineup.querySelectorAll('.lineup__panel');
  var rp=lineup.querySelector('.rail-prev'), rn=lineup.querySelector('.rail-next');
  function activeRail(){var p=lineup.querySelector('.lineup__panel:not([hidden])');return p?p.querySelector('.rail'):null;}
  function step(rail){var c=rail.querySelector('.card');return c?c.getBoundingClientRect().width+22:360;}
  function railState(){var rail=activeRail();if(!rail||!rp||!rn)return;var max=rail.scrollWidth-rail.clientWidth-2;rp.disabled=rail.scrollLeft<=2;rn.disabled=rail.scrollLeft>=max;}
  tabs.forEach(function(t){t.addEventListener('click',function(){
    tabs.forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-selected','false');});
    t.classList.add('is-active');t.setAttribute('aria-selected','true');
    var idx=t.getAttribute('data-tab');
    panels.forEach(function(p){p.hidden=(p.getAttribute('data-panel')!==idx);});
    var rail=activeRail();if(rail)rail.scrollLeft=0;railState();
  });});
  if(rp)rp.addEventListener('click',function(){var r=activeRail();if(r)r.scrollBy({left:-step(r),behavior:'smooth'});});
  if(rn)rn.addEventListener('click',function(){var r=activeRail();if(r)r.scrollBy({left:step(r),behavior:'smooth'});});
  panels.forEach(function(p){var r=p.querySelector('.rail');if(r)r.addEventListener('scroll',railState,{passive:true});});
  railState();
  lineup.querySelectorAll('.wish').forEach(function(w){w.addEventListener('click',function(e){e.preventDefault();w.classList.toggle('on');});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-scale"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var statsEl=document.querySelector('.scale .stats'); if(!statsEl)return;
  var counted=false;
  function runCounts(){if(counted)return;counted=true;
    statsEl.querySelectorAll('b[data-count]').forEach(function(el){
      var target=+el.dataset.count, suf=el.dataset.suffix||'';
      if(reduce){el.textContent=target.toLocaleString('en-US')+suf;return;}
      var dur=1500,t0=null;
      requestAnimationFrame(function tick(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/dur,1),e=1-Math.pow(1-p,3);el.textContent=Math.round(target*e).toLocaleString('en-US')+suf;if(p<1)requestAnimationFrame(tick);});
    });
  }
  if('IntersectionObserver' in window){new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting)runCounts();});},{threshold:.35}).observe(statsEl);}else runCounts();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-showcase"] && !Shopify.designMode) return;
  try {
    
(function(){
  var panels=[].slice.call(document.querySelectorAll('.showcase .panel')); if(!panels.length)return;
  function activate(p){panels.forEach(function(x){x.classList.toggle('active',x===p);});}
  panels.forEach(function(p){p.addEventListener('mouseenter',function(){activate(p);});p.addEventListener('click',function(){activate(p);});p.addEventListener('focus',function(){activate(p);});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-tiktok"] && !Shopify.designMode) return;
  try {
    
(function(){
  var tkCards=[].slice.call(document.querySelectorAll('.tiktok .tk')); if(!tkCards.length)return;
  tkCards.forEach(function(card){
    var v=card.querySelector('video'); if(!v)return;
    card.addEventListener('click',function(){
      if(v.paused){tkCards.forEach(function(o){if(o!==card){var ov=o.querySelector('video');if(ov)ov.pause();o.classList.remove('playing');}});v.muted=false;var pr=v.play();if(pr&&pr.catch)pr.catch(function(){});card.classList.add('playing');}
      else{v.pause();card.classList.remove('playing');}
    });
  });
  var tkSec=document.querySelector('.tiktok');
  if('IntersectionObserver' in window && tkSec){new IntersectionObserver(function(en){en.forEach(function(e){if(!e.isIntersecting)tkCards.forEach(function(c){var cv=c.querySelector('video');if(cv)cv.pause();c.classList.remove('playing');});});},{threshold:.02}).observe(tkSec);}
})();
(function(){
  var modal=document.getElementById('tkModal'); if(!modal)return;
  var frame=document.getElementById('tkFrame');
  function open(url,ig){frame.innerHTML='<iframe src="'+url+'" allow="autoplay; encrypted-media; fullscreen" allowfullscreen scrolling="no"></iframe>';modal.classList.toggle('tkm--ig',!!ig);modal.classList.add('open');modal.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden';}
  function close(){modal.classList.remove('open');modal.setAttribute('aria-hidden','true');frame.innerHTML='';document.documentElement.style.overflow='';}
  [].slice.call(document.querySelectorAll('.tiktok .tk__ext[data-embed]')).forEach(function(a){
    a.addEventListener('click',function(e){var url=a.getAttribute('data-embed');if(!url)return;e.preventDefault();open(url,a.getAttribute('data-platform')==='ig');});
  });
  [].slice.call(modal.querySelectorAll('[data-tk-close]')).forEach(function(b){b.addEventListener('click',close);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('open'))close();});
})();
(function(){
  var rail=document.querySelector('.tiktok__rail'); if(!rail)return;
  rail.addEventListener('wheel',function(e){
    if(e.deltaX!==0)return;
    var d=e.deltaY, atStart=rail.scrollLeft<=0, atEnd=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-1;
    if((d<0&&!atStart)||(d>0&&!atEnd)){rail.scrollLeft+=d;e.preventDefault();}
  },{passive:false});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function(){
  document.querySelectorAll('[data-copy-link]').forEach(function(a){
    a.addEventListener('click',function(e){e.preventDefault();
      if(navigator.clipboard)navigator.clipboard.writeText(location.href);
      var svg=a.innerHTML; a.textContent='Copied'; setTimeout(function(){a.innerHTML=svg;},1400);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
(function(){
  document.querySelectorAll('[data-blog-tabs]').forEach(function(tabs){
    var list=tabs.closest('.blist'); if(!list)return;
    var grid=list.querySelector('[data-blog-grid]');
    tabs.querySelectorAll('.btab').forEach(function(btn){
      btn.addEventListener('click',function(){
        var cat=btn.getAttribute('data-cat');
        tabs.querySelectorAll('.btab').forEach(function(b){b.classList.toggle('is-on',b===btn);});
        grid.querySelectorAll('.post').forEach(function(p){
          var cats=(p.getAttribute('data-cat')||'').split(' ');
          p.style.display=(cat==='all'||cats.indexOf(cat)>-1)?'':'none';
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function(){
  document.querySelectorAll('[data-cf-drawer]').forEach(function(drawer){
    var openBtns = document.querySelectorAll('[data-cf-open]');
    var closeBtns = drawer.querySelectorAll('[data-cf-close]');
    function open(){ drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
    function close(){ drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
    openBtns.forEach(function(b){ b.addEventListener('click', open); });
    closeBtns.forEach(function(b){ b.addEventListener('click', close); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
(function(){
  var wrap=document.querySelector('[data-page-wrap]'); if(!wrap)return;
  var bodyEl=wrap.querySelector('[data-page-body]'), toc=wrap.querySelector('[data-page-toc]');
  var h2s=[].slice.call(bodyEl.querySelectorAll('h2'));
  if(h2s.length<2){ wrap.classList.add('no-toc'); return; }
  var links=[];
  h2s.forEach(function(h,i){
    if(!h.id){ h.id='sec-'+i+'-'+h.textContent.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,''); }
    var a=document.createElement('a'); a.href='#'+h.id; a.textContent=h.textContent;
    a.addEventListener('click',function(e){e.preventDefault();window.scrollTo({top:h.getBoundingClientRect().top+window.scrollY-90,behavior:'smooth'});});
    toc.appendChild(a); links.push(a);
  });
  function spy(){
    var y=window.scrollY+120, cur=h2s[0];
    h2s.forEach(function(s){ if(s.getBoundingClientRect().top+window.scrollY<=y)cur=s; });
    links.forEach(function(a){ a.classList.toggle('is-on', a.getAttribute('href')==='#'+cur.id); });
  }
  window.addEventListener('scroll',spy,{passive:true}); spy();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function(){
  var root=document.querySelector('.pdp'); if(!root)return;
  var vs; try{ vs=JSON.parse(root.querySelector('[data-variants]').textContent); }catch(e){ vs=[]; }
  var idInput=root.querySelector('#variantId');
  var MM; try{ MM=JSON.parse(root.querySelector('[data-variant-money]').textContent); }catch(e){ MM={}; }
  var opts=[];
  root.querySelectorAll('.opt').forEach(function(o,i){var on=o.querySelector('.vopt.on');opts[i]=on?on.dataset.val:null;});
  function current(){for(var k=0;k<vs.length;k++){var v=vs[k],ok=true;for(var i=0;i<opts.length;i++){if(v.options[i]!==opts[i]){ok=false;break;}}if(ok)return v;}return null;}
  function apply(){var v=current();if(!v)return;idInput.value=v.id;
    var m=MM[v.id];
    if(m){
      var pv=root.querySelector('.price__val'); if(pv)pv.textContent=m.p;
      var pw=root.querySelector('.price__was'); if(pw){pw.textContent=m.c;pw.hidden=!m.on;}
      var pz=root.querySelector('.price__save'); if(pz){pz.textContent='Save '+m.s;pz.hidden=!m.on;}
      var sv=document.querySelector('.stickybar__val'); if(sv)sv.textContent=m.p;
      var sw=document.querySelector('.stickybar__was'); if(sw){sw.textContent=' '+m.c;sw.hidden=!m.on;}
    }
    if(v.featured_image&&v.featured_image.src){var mi=root.querySelector('#mainImg');
      hideVids();                                                  // 换变体先收起视频，否则会盖住新图
      if(mi){mi.hidden=false;mi.src=v.featured_image.src;}}
    var add=root.querySelector('.addcart'),buy=root.querySelector('.buynow');
    [add,buy].forEach(function(b){if(!b)return;if(v.available)b.removeAttribute('disabled');else b.setAttribute('disabled','');});
    var sp=add&&add.querySelector('span');if(sp)sp.textContent=v.available?'Add to cart':'Sold out';
    var sbc=document.getElementById('stickybarCta');if(sbc){var sbs=sbc.querySelector('span');if(sbs)sbs.textContent=v.available?'Add to cart':'Sold out';}
    if(v.featured_image&&v.featured_image.src){var si=document.querySelector('.stickybar__img');if(si)si.src=v.featured_image.src;}
  }
  root.querySelectorAll('.opt').forEach(function(o,idx){o.querySelectorAll('.vopt').forEach(function(btn){btn.addEventListener('click',function(){o.querySelectorAll('.vopt').forEach(function(b){b.classList.remove('on');});btn.classList.add('on');opts[idx]=btn.dataset.val;var lbl=o.querySelector('.optName');if(lbl)lbl.textContent=btn.dataset.val;apply();});});});
  function hideVids(){root.querySelectorAll('.gal__vid').forEach(function(d){
    d.hidden=true; var v=d.querySelector('video'); if(v)v.pause();});}
  function showMedia(t){
    var mi=root.querySelector('#mainImg'), idx=t.getAttribute('data-vid-idx');
    hideVids();
    if(idx!==null){
      var box=root.querySelector('.gal__vid[data-vid-idx="'+idx+'"]');
      if(box){ box.hidden=false; if(mi)mi.hidden=true;
        var v=box.querySelector('video');
        if(v){var pr=v.play(); if(pr&&pr.catch)pr.catch(function(){});}  // 被自动播放策略拦就留 controls 给用户点
        return; }
    }
    if(mi){mi.hidden=false;mi.src=t.dataset.src;}
  }
  root.querySelectorAll('.gal__thumb').forEach(function(t){var pi=new Image();pi.src=t.dataset.src;t.addEventListener('click',function(){root.querySelectorAll('.gal__thumb').forEach(function(x){x.classList.remove('on');});t.classList.add('on');showMedia(t);});});
  // 左右按钮：直接 click 对应缩略图，高亮/换图/预加载逻辑不重复实现一遍
  function galGo(d){var ts=[].slice.call(root.querySelectorAll('.gal__thumb'));if(ts.length<2)return;
    var i=-1;ts.forEach(function(x,k){if(x.classList.contains('on'))i=k;});if(i<0)i=0;
    var n=(i+d+ts.length)%ts.length;ts[n].click();
    if(ts[n].scrollIntoView)ts[n].scrollIntoView({block:'nearest',inline:'nearest'});}
  var gp=root.querySelector('[data-gal-prev]'),gn=root.querySelector('[data-gal-next]');
  if(gp)gp.addEventListener('click',function(){galGo(-1);});
  if(gn)gn.addEventListener('click',function(){galGo(1);});
  var q=1,qval=root.querySelector('#qVal'),qin=root.querySelector('#qInput');
  var qm=root.querySelector('#qMinus'),qp=root.querySelector('#qPlus');
  if(qm)qm.addEventListener('click',function(){q=Math.max(1,q-1);qval.textContent=q;if(qin)qin.value=q;});
  if(qp)qp.addEventListener('click',function(){q=q+1;qval.textContent=q;if(qin)qin.value=q;});
  function upsellItems(){var a=[];root.querySelectorAll('.up').forEach(function(l){var cb=l.querySelector('.up__cb');if(cb&&cb.checked)a.push({id:parseInt(l.dataset.upId,10),quantity:1});});return a;}
  root.querySelectorAll('.up').forEach(function(l){l.addEventListener('click',function(){var cb=l.querySelector('.up__cb');cb.checked=!cb.checked;l.classList.toggle('on',cb.checked);var el=root.querySelector('[data-ups-count]');if(el)el.textContent=root.querySelectorAll('.up__cb:checked').length;});});
  root.querySelectorAll('[data-ups-paged]').forEach(function(box){
    var list=box.querySelector('[data-ups-list]'),pager=box.querySelector('[data-ups-pager]');
    var size=parseInt(box.dataset.upsPagesize,10)||4;
    var items=[].slice.call(list.children); if(items.length<=size)return;
    var page=0, pages=Math.ceil(items.length/size);
    var info=box.querySelector('[data-ups-pageinfo]'),prev=box.querySelector('[data-ups-prev]'),next=box.querySelector('[data-ups-next]');
    function show(){items.forEach(function(el,i){el.style.display=(i>=page*size&&i<(page+1)*size)?'':'none';});
      if(info)info.textContent=(page+1)+' / '+pages; if(prev)prev.disabled=page===0; if(next)next.disabled=page===pages-1;}
    if(pager)pager.hidden=false;
    if(prev)prev.addEventListener('click',function(){if(page>0){page--;show();}});
    if(next)next.addEventListener('click',function(){if(page<pages-1){page++;show();}});
    show();
  });
  function addToCart(then){var add=root.querySelector('.addcart');if(!add||add.hasAttribute('aria-busy')||add.hasAttribute('disabled'))return;add.setAttribute('aria-busy','true');
    fetch(window.Shopify.routes.cart_add_url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(idInput.value,10),quantity:q}].concat(upsellItems())})})
     .then(function(r){return r.json();}).then(function(res){
       if(res&&res.status){var s=add.querySelector('span');if(s){var o=s.textContent;s.textContent='Unavailable';setTimeout(function(){s.textContent=o;},1600);}return;}
       if(then){then();return;}
       document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
       var s=add.querySelector('span');if(s){var o=s.textContent;s.textContent='Added ✓';setTimeout(function(){s.textContent=o;},1600);}
     }).catch(function(){}).finally(function(){add.removeAttribute('aria-busy');});
  }
  var addBtn=root.querySelector('.addcart');if(addBtn)addBtn.addEventListener('click',function(e){e.preventDefault();addToCart();});
  var buyBtn=root.querySelector('.buynow');if(buyBtn)buyBtn.addEventListener('click',function(e){e.preventDefault();addToCart(function(){window.location.href='/checkout';});});
  root.querySelectorAll('.promo').forEach(function(box){
    if(box.dataset.deadline&&Date.now()>(+box.dataset.deadline)*1000){box.style.display='none';return;}
    var btn=box.querySelector('[data-copy]');var code=box.dataset.code;
    function copy(e){if(e){e.preventDefault();e.stopPropagation();}if(navigator.clipboard)navigator.clipboard.writeText(code).then(function(){var t=box.querySelector('[data-copytext]');if(t){var o=t.textContent;t.textContent='Copied ✓';setTimeout(function(){t.textContent=o;},1600);}});}
    if(btn)btn.addEventListener('click',copy);
    box.addEventListener('click',function(e){if(e.target.closest('[data-copy]'))return;copy(e);});
  });
  apply();

  var sbar=document.getElementById('stickybar'),cta=root.querySelector('.buy__cta');
  if(sbar&&cta&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      var e=entries[0];
      sbar.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0);
    },{threshold:0});
    io.observe(cta);
    var sbarCta=document.getElementById('stickybarCta');
    if(sbarCta)sbarCta.addEventListener('click',function(){
      cta.scrollIntoView({behavior:'smooth',block:'center'});
      setTimeout(function(){
        var target=cta.querySelector('.addcart[disabled]')?cta.querySelector('.buynow'):cta.querySelector('.addcart');
        if(target){target.classList.add('jump-flash');setTimeout(function(){target.classList.remove('jump-flash');},1200);}
      },450);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manuals-list"] && !Shopify.designMode) return;
  try {
    
(function(){
  var input=document.querySelector('[data-manuals-search]');
  var list=document.querySelector('[data-manuals-list]');
  if(!input||!list)return;
  var none=document.querySelector('[data-manuals-none]');
  function apply(){
    var term=input.value.trim().toLowerCase(), shown=0;
    list.querySelectorAll('.mcard').forEach(function(c){
      var vis=!term||(c.getAttribute('data-name')||'').indexOf(term)>-1;
      c.style.display=vis?'':'none'; if(vis)shown++;
    });
    list.querySelectorAll('.msec').forEach(function(sec){
      var any=[].slice.call(sec.querySelectorAll('.mcard')).some(function(c){return c.style.display!=='none';});
      sec.style.display=any?'':'none';
    });
    if(none)none.style.display=shown?'none':'block';
  }
  input.addEventListener('input',apply);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manuals-tutorials"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.mtut .tcard[data-yt]').forEach(function(card){
    function play(){
      if(card.classList.contains('playing'))return;
      var id=card.getAttribute('data-yt');if(!id)return;
      var f=document.createElement('iframe');
      f.src='https://www.youtube.com/embed/'+id+'?autoplay=1&playsinline=1&rel=0';
      f.allow='autoplay; encrypted-media; picture-in-picture';f.setAttribute('allowfullscreen','');
      card.querySelector('.tcard__thumb').appendChild(f);card.classList.add('playing');
    }
    card.addEventListener('click',play);
    card.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();play();}});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-battery"]) return;
  try {
    
(function(){
  if(window.__whReveal)return;window.__whReveal=1;
  var els=document.querySelectorAll('[data-wh-reveal]');
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in');});return;}
  var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.2});
  els.forEach(function(e){io.observe(e);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-creators"]) return;
  try {
    
(function(){
  document.querySelectorAll('.creators .ytcard').forEach(function(card){
    function play(){
      if(card.classList.contains('playing'))return;
      var id=card.getAttribute('data-yt');if(!id)return;
      var thumb=card.querySelector('.ytthumb');
      var f=document.createElement('iframe');
      f.src='https://www.youtube.com/embed/'+id+'?autoplay=1&playsinline=1&rel=0';
      f.allow='autoplay; encrypted-media; picture-in-picture';f.setAttribute('allowfullscreen','');
      thumb.appendChild(f);card.classList.add('playing');
    }
    card.addEventListener('click',play);
    card.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();play();}});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"]) return;
  try {
    
(function(){
  document.querySelectorAll('.faq .faqitem__q').forEach(function(btn){
    btn.addEventListener('click',function(){var it=btn.closest('.faqitem');it.classList.toggle('open');});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-range"]) return;
  try {
    
(function(){
  if(!window.__whReveal){window.__whReveal=1;
    var els=document.querySelectorAll('[data-wh-reveal]');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.2});
      els.forEach(function(e){io.observe(e);});
    } else {els.forEach(function(e){e.classList.add('in');});}
  }
  document.querySelectorAll('.range .rnum').forEach(function(el){
    var to=parseInt(el.getAttribute('data-to'),10)||0,done=false;
    function run(){if(done)return;done=true;var t0=null,d=1400;
      function step(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/d,1);el.textContent=Math.round(p*to);if(p<1)requestAnimationFrame(step);}
      requestAnimationFrame(step);}
    if('IntersectionObserver' in window){var o=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){run();o.unobserve(e.target);}});},{threshold:.4});o.observe(el);}
    else run();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-smart"]) return;
  try {
    
(function(){
  document.querySelectorAll('.smart').forEach(function(sec){
    var track=sec.querySelector('.smart__track');
    sec.querySelectorAll('.smart__nav button').forEach(function(b){
      b.addEventListener('click',function(){
        var card=track.querySelector('.scard');var w=card?card.offsetWidth+18:320;
        track.scrollBy({left:parseInt(b.getAttribute('data-dir'),10)*w,behavior:'smooth'});
      });
    });
  });
  function open(m){m.hidden=false;document.body.style.overflow='hidden';}
  function close(m){m.hidden=true;document.body.style.overflow='';}
  document.querySelectorAll('.smart .scard[data-modal]').forEach(function(card){
    function go(){var m=document.getElementById(card.getAttribute('data-modal'));if(m)open(m);}
    card.addEventListener('click',go);
    card.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();go();}});
  });
  document.querySelectorAll('.fmodal').forEach(function(m){
    m.querySelector('.fmodal__bg').addEventListener('click',function(){close(m);});
    m.querySelector('.fmodal__x').addEventListener('click',function(){close(m);});
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){document.querySelectorAll('.fmodal:not([hidden])').forEach(close);}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-splits"]) return;
  try {
    
document.querySelectorAll('.story').forEach(function(sec){
  var beats=[].slice.call(sec.querySelectorAll('.story__beat'));
  var layers=[].slice.call(sec.querySelectorAll('.story__layer'));
  var cur=sec.querySelector('.story__cur');
  if(beats.length<2) return;
  var active=-1, ticking=false;
  function pick(){
    ticking=false;
    var mid=window.innerHeight/2, best=0, bestD=1e9;
    beats.forEach(function(b,i){
      var r=b.getBoundingClientRect();
      var d=Math.abs((r.top+r.height/2)-mid);
      if(d<bestD){bestD=d;best=i;}
    });
    if(best===active) return; active=best;
    beats.forEach(function(b){b.classList.toggle('is-on', +b.dataset.idx===best);});
    layers.forEach(function(l){l.classList.toggle('is-on', +l.dataset.idx===best);});
    if(cur) cur.textContent=('0'+(best+1)).slice(-2);
  }
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(pick); } }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll, {passive:true});
  pick();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"]) return;
  try {
    
(function(){
  document.querySelectorAll('.pvideo__frame[data-wh-video]').forEach(function(f){
    function play(){
      if(f.classList.contains('playing'))return;
      var t=f.querySelector('[data-wh-video-src]');
      if(t){f.appendChild(t.content.cloneNode(true));}
      f.classList.add('playing');
    }
    f.addEventListener('click',play);
    var p=f.querySelector('.pvideo__play');
    if(p)p.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();play();}});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.shero .shcd[data-deadline]').forEach(function(cd){
  var T=new Date(cd.dataset.deadline).getTime();
  if(isNaN(T)) return;
  var elD=cd.querySelector('[data-d]'),elH=cd.querySelector('[data-h]'),elM=cd.querySelector('[data-m]'),elS=cd.querySelector('[data-s]');
  function pad(n){return String(n).padStart(2,'0');}
  function tick(){
    var d=Math.max(0,T-Date.now());
    var D=Math.floor(d/864e5); d-=D*864e5;
    var H=Math.floor(d/36e5); d-=H*36e5;
    var M=Math.floor(d/6e4); d-=M*6e4;
    var S=Math.floor(d/1e3);
    elD.textContent=pad(D); elH.textContent=pad(H); elM.textContent=pad(M); elS.textContent=pad(S);
  }
  tick(); setInterval(tick,1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-lineup"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.slineup').forEach(function(sec){
  var tabs=sec.querySelector('.sfilters'); if(!tabs) return;
  var cards=[].slice.call(sec.querySelectorAll('.sgrid .scard'));
  tabs.addEventListener('click',function(e){
    var b=e.target.closest('button'); if(!b) return;
    [].forEach.call(tabs.children,function(x){ x.classList.toggle('on', x===b); });
    var f=b.dataset.f;
    cards.forEach(function(c){ c.style.display = (f==='all'||c.dataset.cat===f)?'':'none'; });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-stories"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sstories').forEach(function(sec){
  var t=sec.querySelector('.sstrack');
  sec.querySelector('.ss-next').onclick=function(){ t.scrollBy({left:t.clientWidth*.8,behavior:'smooth'}); };
  sec.querySelector('.ss-prev').onclick=function(){ t.scrollBy({left:-t.clientWidth*.8,behavior:'smooth'}); };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-youtube"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.syt').forEach(function(sec){
  var t=sec.querySelector('.syttrack');
  sec.querySelector('.sy-next').onclick=function(){ t.scrollBy({left:t.clientWidth*.8,behavior:'smooth'}); };
  sec.querySelector('.sy-prev').onclick=function(){ t.scrollBy({left:-t.clientWidth*.8,behavior:'smooth'}); };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.slocator').forEach(function(sec){
    var tabs=sec.querySelector('[data-store-tabs]'), search=sec.querySelector('[data-store-search]'),
        grid=sec.querySelector('[data-store-grid]'), countEl=sec.querySelector('[data-store-count]'),
        none=sec.querySelector('[data-store-none]');
    var cards=[].slice.call(grid.querySelectorAll('.store'));
    var state='all', term='';
    function apply(){
      var shown=0;
      cards.forEach(function(c){
        var okS=(state==='all'||c.getAttribute('data-state')===state);
        var okT=(!term||(c.getAttribute('data-q')||'').indexOf(term)>-1);
        var vis=okS&&okT; c.style.display=vis?'':'none'; if(vis)shown++;
      });
      if(countEl)countEl.textContent=shown+(shown===1?' store':' stores');
      if(none)none.style.display=shown?'none':'block';
    }
    if(tabs)tabs.querySelectorAll('.stab').forEach(function(b){b.addEventListener('click',function(){
      state=b.getAttribute('data-state');
      tabs.querySelectorAll('.stab').forEach(function(x){x.classList.toggle('is-on',x===b);}); apply();
    });});
    if(search)search.addEventListener('input',function(){term=search.value.trim().toLowerCase();apply();});
    apply();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
